'use client';

import type { TriggerDropdownProps } from '@/components/tiptap-editor/tiptap-ui/trigger-dropdown';
import { TriggerDropdown, useTriggerDropdown } from '@/components/tiptap-editor/tiptap-ui/trigger-dropdown';
import type { Editor } from '@tiptap/react';

// --- Icons ---
import { CircleSmall, DivideIcon, EqualNotIcon, InfinityIcon, PiIcon, RadicalIcon, X } from 'lucide-react';

const symbolsOptions = [
    {
        label: 'Multiplication',
        icon: X,
        command: (editor: Editor) => editor.commands.insertContent('×'),
    },
    {
        label: 'Division',
        icon: DivideIcon,
        command: (editor: Editor) => editor.commands.insertContent('÷'),
    },
    {
        label: 'Pi',
        icon: PiIcon,
        command: (editor: Editor) => editor.commands.insertContent('π'),
    },
    {
        label: 'Degree',
        icon: CircleSmall,
        command: (editor: Editor) => editor.commands.insertContent('°'),
    },
    {
        label: 'Square Root',
        icon: RadicalIcon,
        command: (editor: Editor) => editor.commands.insertContent('√'),
    },
    {
        label: 'Infinity',
        icon: InfinityIcon,
        command: (editor: Editor) => editor.commands.insertContent('∞'),
    },
    {
        label: 'Not Equal',
        icon: EqualNotIcon,
        command: (editor: Editor) => editor.commands.insertContent('≠'),
    },
];

export function useSymbolsTrigger() {
    return useTriggerDropdown();
}

type SymbolsTriggerDropdownProps = Omit<TriggerDropdownProps, 'options' | 'ariaLabel' | 'placeholder' | 'emptyMessage'>;

export function SymbolsTriggerDropdown(props: SymbolsTriggerDropdownProps) {
    return (
        <TriggerDropdown
            {...props}
            options={symbolsOptions}
            ariaLabel="Symbols"
            placeholder="Filter symbols..."
            emptyMessage="No symbols found"
            dataSelector="tiptap-symbols-trigger-dropdown"
        />
    );
}
